import { useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { AppModel } from "../../../app/app-model";
import { PatientSubpage } from "../common/patient-subpage";
import { PatientProfileChartTabs } from "./patient-profile-chart-tabs";

export const ProfileRoute = observer(function ProfileRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  return (
    <PatientSubpage title={t`Trends`}>
      <PatientProfileChartTabs patient={patient} api={props.app.seerlinqApi} />
    </PatientSubpage>
  );
});
